import type {
  QueueExecuteProcessorMutation,
  QueueExecuteProcessorMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const QUEUE_EXECUTE_PROCESSOR: TypedDocumentNode<
  QueueExecuteProcessorMutation,
  QueueExecuteProcessorMutationVariables
> = gql`
  mutation QueueExecuteProcessor($input: ExecuteProcessorInput!) {
    queueExecuteProcessor(input: $input) {
      queued
      message
      taskName
      processorInstanceId
      parentMessageId
    }
  }
`;
